export const UPLOAD_FILE_ACCEPTED_TYPE_MAP: Record<string, string> = {
  "application/pdf": "PDF",
};
